import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import { VersaoService } from '../versao.service'
import { ExibirMenuService } from '../../../shared/exibir-menu.service'
import { AcessoApiService } from '../../../../acessoApi.service'
import { DadosAcessoService } from '../../../../dadosAcesso.service'
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-edit-versao',
  templateUrl: './edit-versao.component.html',
  styleUrls: ['./edit-versao.component.css']
})
export class EditVersaoComponent implements OnInit {

  public COD_LOJA : number
  public ID_SIS: number
  public NOME_SIS: string
  public modal: string = ""
  public VERSAO: string
  public QTDE_PDV: number
  public TIPO_INST: string
  public OBS_INST: string
  public id_inst: any

  public sistemas: any
  public versoes: any
  public dados: any

  constructor(private notificacao: NotificationsService, private acessoAPI: AcessoApiService, private versaoService: VersaoService, private exibirItens: ExibirMenuService, private dadosAcesso: DadosAcessoService, private router: Router) { 
    if(sessionStorage.getItem('cod_loja') === null){

      this.router.navigate(["/"])
    }
    this.exibirItens.setItensVisiveis(true);

    

    this.acessoAPI.getListaSistemas().subscribe(res =>{
    
      this.sistemas = res
    })
  
    this.acessoAPI.getListaVersoes().subscribe(res =>{
      
      this.versoes = res
  
    })

    this.id_inst = this.versaoService.recuperarID_SIS()
    this.acessoAPI.editarVersao(this.id_inst).subscribe( data=> {
      this.dados = data
      this.COD_LOJA = data[0].COD_LOJA
      this.ID_SIS = data[0].ID_SIS
      this.NOME_SIS = data[0].NOME_SIS
      this.VERSAO = data[0].VERSAO
      this.QTDE_PDV = data[0].QTDE_PDV
      this.TIPO_INST = data[0].TIPO_INST
      this.OBS_INST = data[0].OBS_INST

    })

    


  }

  ngOnInit() {
  }

  RetornarVersao(){
    this.router.navigate(["/administrativo/versao-loja"])
  }


  changeSis(sistema){
    
    this.ID_SIS = parseInt(sistema.value);
 }

 changeVersao(versao){
   this.VERSAO = versao.value
 }

 GetCodLoja(codLoja: Event){
   this.COD_LOJA = parseInt((<HTMLInputElement>codLoja.target).value)
 }

 getQtdade(quantidade: Event){
  this.QTDE_PDV = parseInt((<HTMLInputElement>quantidade.target).value)
 }

 getInsta(insta){
   this.TIPO_INST = (<HTMLInputElement>insta.target).value

 }

 getObserv(observ: Event){

  this.OBS_INST = (<HTMLInputElement>observ.target).value

 }

 enviarEdicao(){
    this.acessoAPI.PostarEdicao(this.id_inst, this.ID_SIS, this.NOME_SIS,this.COD_LOJA, this.VERSAO, this.QTDE_PDV, this.TIPO_INST, this.OBS_INST).subscribe(data =>{
      this.notificacao.success(
        'Solicitação enviada!',
        'Edição feita com sucesso!',
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      )
    }, error => {
      
      this.notificacao.error(
        'Solicitação não enviada!',
        error._body,
        {
          timeOut: 2000,
          showProgressBar: false,
          pauseOnHover: false,
          clickToClose: false,
          maxLength: 2
        }
      )


    })
 }



}



// WEBPACK FOOTER //
// ./src/app/pages/administracao/versao/edit-versao/edit-versao.component.ts